import { ERRORS } from './errors';

export enum Colors {
  Orange = 'orange',
  Purple = 'purple',
  Grey = 'grey',
}

export const getColorHexValue = (color: Colors) => {
  const dict: Record<Colors, string> = {
    [Colors.Purple]: '#5E3DC2',
    [Colors.Grey]: '#938FA8',
    [Colors.Orange]: '#FF5B24',
  };

  return dict[color] ?? dict[Colors.Purple];
};

export async function backoffRetry<T>(
  fn: () => Promise<T>,
  attempts = 2,
  backoff = 500
): Promise<T> {
  let attempt = 0;
  while (attempt++ < attempts) {
    try {
      return await fn();
    } catch (e) {
      if (attempt >= attempts) {
        throw e;
      }
      await wait(backoff);
    }
  }
  throw new Error('Unreachable');
}

export async function wait(time = 1000): Promise<void> {
  return new Promise((res) => setTimeout(res, time));
}

export enum PARAMS {
  TOKEN = 'token',
  CARD_PAGE_TOKEN = 'cardPageToken',
  PAYMENT_TOKEN = 'paymentToken',
  MD = 'MD',
  PARES = 'PaRes',
  REDIRECT_RESULT = 'redirectResult',
}

export function getParameterByName(param: PARAMS, url = window.location.href): string | null {
  const name = param.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function isWebView(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('vipps') || userAgent.includes('mobilepay');
}

export type OptionalErrorResponseTuple<R, E = Error> = [E, null] | [null, R];

export async function networkPollingAndRetry<T>(
  request: () => Promise<T>,
  retryLimit = 1
): Promise<OptionalErrorResponseTuple<T>> {
  let result: T | null = null;
  while (retryLimit-- > 0) {
    try {
      result = await request();
      return [null, result];
    } catch (e) {
      if (e instanceof Response) {
        if (e.status >= 400 && e.status < 500) {
          return [new Error(await e.text().catch(() => ERRORS.UNKNOWN)), null];
        }
      }
    }
  }
  return [new Error(ERRORS.NETWORK_ISSUE), null];
}

export function getRootHost(): string {
  const port = window.location.port.length === 0 ? '' : `:${window.location.port}`;
  const scheme = window.location.hostname === 'localhost' ? 'http' : 'https';
  return `${scheme}://${window.location.hostname}${port}`;
}
